/**
 * RestoID — Device activation succeeded (`/device/success`).
 * ---------------------------------------------------------------------------
 * RestoID presentation of the PRISTINE upstream `src/pages/Device/Success.tsx`.
 * That page is pure markup — no hooks, no guards, no navigation — so nothing
 * behavioral exists to preserve beyond the two phrase keys and the page title,
 * and both are kept on their upstream keys so Logto Custom Phrases still apply.
 *
 * Deliberate differences from upstream, all presentational:
 *   - `StaticPageLayout` becomes `FirstScreenLayout`, which is the layout every
 *     ported RestoID screen uses and which also renders the `PageMeta` upstream
 *     rendered by hand — same `titleKey`, so the document title is unchanged.
 *   - The green circle + `check-mark.svg` become RestoID's lime `HeroTile` with
 *     the shared `check` icon; title and description become one `ScreenHead`, so
 *     the type scale matches every other screen instead of Logto's `--font-*`.
 *   - Head before tile, which inverts upstream's mark-then-sentence order. Every
 *     other `HeroTile` screen in the custom layer (MfaOnboarding, PasskeySetup,
 *     MfaWebAuthnBinding, MfaWebAuthnVerification) is head-first, and `ScreenHead`
 *     is built for it: it carries its own `marginBottom`, which as the last child
 *     of a `Stack` would hang off the bottom as dead space under the final line.
 * Swapped in for `./pages/Device/Success` via `src/App.tsx`.
 */
import { useTranslation } from 'react-i18next';

import FirstScreenLayout from '@/Layout/FirstScreenLayout';

import { HeroTile, ScreenHead, Stack } from '../components/restoid';

const DeviceSuccess = () => {
  const { t } = useTranslation();

  return (
    <FirstScreenLayout pageMeta={{ titleKey: 'description.device_activation_success' }}>
      <Stack gap={18}>
        <ScreenHead
          title={t('description.device_activation_success')}
          sub={t('description.device_activation_success_description')}
        />
        <HeroTile icon="check" />
      </Stack>
    </FirstScreenLayout>
  );
};

export default DeviceSuccess;
